export default __webpack_public_path__ + "static/NBInternationalPro-Regular-d3442e44e224255cdb5a9755675dd218.woff";